import React from "react";
import parse from 'html-react-parser';

const renderNode = (node) => {
  if (!node) return null;

  switch (node.type) {
    case "heading": {
      const HeadingTag = `h${node.level || 1}`;
      return (
        <HeadingTag >
          {node.children && node.children.map((child, index) => renderNode(child))}
        </HeadingTag>
      );
    }
    case "paragraph":
      return (
        <p>
          {node.children && node.children.map((child, index) => renderNode(child))}
        </p>
      );
    case "list": {
      const ListTag = node.format === "unordered" ? "ul" : "ol";
      return (
        <ListTag className={`${node.indentLevel==1&&"ml-7"}`}>
          {node.children && node.children.map((child, index) => renderNode(child))}
        </ListTag>
      );
    }
    case "list-item":
      return (
        <li>
          {node.children && node.children.map((child, index) => renderNode(child))}
        </li>
      );
    case "link":
      return (
        <a href={node.url} target="_blank" rel="noopener noreferrer">
          {node.children && node.children.map((child, index) => renderNode(child))}
        </a>
      );
    case "text":
      let content = node.text;
      if (node.bold) content = <strong>{content}</strong>;
      if (node.italic) content = <em>{content}</em>;
      if (node.underline) content = <u>{content}</u>;
      if (node.strikethrough) content = <s>{content}</s>;
      console.log(content)
      if(typeof content=="string" && content?.includes("<parse>")){
        let parseContent  = content.match(/<parse>(.*?)<\/parse>/);
        if(parseContent?.length>1) parseContent = parseContent[1];
        else {
          parseContent = null;
          return
        }
        parseContent = `<div class="overflow-auto">${parseContent}</div>`
        content = parse(parseContent);
      }

      return content;
    default:
      return null;
  }
};

const RichTextRenderer = ({ content }) => {
  if (!content) return null;
  return content.map((node, index) => (
    <React.Fragment key={index}>{renderNode(node)}</React.Fragment>
  ));
};

export default RichTextRenderer;
